module.exports = __webpack_public_path__ + "static/img/user_story_banner_mobile.dcd67678.jpg";